import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Card from 'src/components/sharedComponents/Card/Card';
import CardBody from 'src/components/sharedComponents/Card/CardBody';
import styles from 'src/assets/jss/material-dashboard-react/views/componentsSections/sectionCards';
import ExtensionIcon from '@material-ui/icons/Extension';
import Button from 'src/components/sharedComponents/CustomButtons/Button';
import CardFooter from 'src/components/sharedComponents/Card/CardFooter';
import AttachFileIcon from '@material-ui/icons/AttachFile';

const BASE_URL = 'https://lucia-static.lucia.com.co/';
const DEFAULT_IMG = 'https://storage.googleapis.com/lucia-static.lucia.com.co/page/img/boxnew.png';

const newStyles = {
  ...styles,
  cardBodyTitle: {
    color: 'white',
  },
};

const useStyles = makeStyles(newStyles);

const CardRotateEffect = (props) => {
  const {
    handleOpenModal,
    addToMapValue,
    stateEdit,
    imagen,
    linea,
    index,
  } = props;
  const classes = useStyles();

  return (
    <>
      <Card className={classes.cardRotate}>
        <div role="button" className={classes.front}>
          <CardBody
            style={{ minHeight: '20em' }}
            className={classes.cardBodyRotate}
          >
            <div style={{ padding: '10px' }}>
              <span>
                <strong>{linea.toUpperCase() || 'Sin Título'}</strong>
              </span>
            </div>
            <section>
              <img
                src={`${BASE_URL}${imagen}` || DEFAULT_IMG}
                alt={imagen}
                width="50%"
                height="50%"
                className={`${classes.imgRounded} ${classes.imgFluid}`}
              />
            </section>
          </CardBody>
          <CardFooter>
            <Button
              link
              onClick={() => handleOpenModal({ open: true, isEdit: true, index })}
            >
              <AttachFileIcon style={{ color: '#FFA500' }} />
              {' '}
              Ver
            </Button>
            <Button disabled={stateEdit} onClick={addToMapValue} link>
              <ExtensionIcon style={{ color: '#FFA500' }} />
              {' '}
              Add
            </Button>
            <br />
          </CardFooter>
        </div>
      </Card>
    </>
  );
};

export default CardRotateEffect;
